import { metrics } from '@atlassian/browser-metrics';

import {
	type PageSegmentLoadPerformanceEventConfig,
	BMEventsType,
} from '@atlassian/browser-metrics/types';

export type LoadingMetricContentType = 'editPage' | 'viewPage';

export const iframeOnloadMetric = () =>
	metrics.interaction({
		key: 'embedded-confluence-time-to-iframe-onload',
	});

export const embeddedViewToEditTransitionMetric = () =>
	metrics.interaction({
		key: 'embedded-confluence-view-to-edit-transition',
	});

const loadingMetricsConfig: Record<
	LoadingMetricContentType,
	PageSegmentLoadPerformanceEventConfig
> = {
	viewPage: {
		key: 'embedded-confluence-view-page-iframe',
		type: BMEventsType.PAGE_SEGMENT_LOAD,
	},
	editPage: {
		key: 'embedded-confluence-edit-page-iframe',
		type: BMEventsType.PAGE_SEGMENT_LOAD,
	},
};

export const embeddedConfluenceIframeLoadMetrics = (contentType: LoadingMetricContentType) =>
	metrics.pageSegmentLoad(loadingMetricsConfig[contentType]);
